// The WhatsApp business number as people read it. Shown only as a WhatsApp
// link's label, never as a tel: link: the site does not offer calls (Robin,
// 26 Oct 2026; docs/DECISIONS.md).
export const PHONE_NUMBER = '07944 858218'

// WhatsApp number - country code + number, no leading + (wa.me URL format).
export const WHATSAPP_NUMBER = '447944858218'

// Build a wa.me URL with an optional pre-filled message that opens
// WhatsApp's send-to dialog already addressed to our business number.
export const whatsappUrl = (text) => {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`
  return text ? `${base}?text=${encodeURIComponent(text)}` : base
}
